import { makeStyles } from '@material-ui/core';

import { AstropayLogo } from 'common/config/assets';

export const useVoucherStyles = makeStyles((theme) => ({
  root: {
    background: theme.colors.Gradient_1,
    borderRadius: '12px',

    minWidth: 174,
    minHeight: 110,
    padding: theme.spacing(2, 2.5),
    margin: theme.spacing(2),
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',

    [theme.breakpoints.up('sm')]: {
      minWidth: 238,
      minHeight: 151,
    },

    '& .astropaylogo': {
      width: '80px',
      height: '50px',
      background: `url(${AstropayLogo})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'contain',
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 10,
      left: 20,
    },

    '&.active': {
      outline: `${theme.spacing(0.3)}px solid ${theme.colors.PrimaryActive}`,
    },

    '&.nonClickable': {
      pointerEvents: 'none',
    },

    '&.disabled': {
      opacity: 0.5,
      cursor: 'not-allowed !important',
    },
    ['&:first-child:not(:only-of-type)']: {
      marginLeft: theme.spacing(0),
    },
    ['&:last-child']: {
      marginRight: theme.spacing(1),
    },
  },
  selectedIcon: {
    color: theme.colors.global.Neutral_100,
    '& .fa-secondary': {
      color: theme.colors.PrimaryActive,
      opacity: 1,
    },
  },
  voucherInfo: {
    [theme.breakpoints.up('sm')]: { display: 'flex' },
    '& >span': { display: 'block' },
    color: 'white',
    fontSize: theme.spacing(2.3),
    textTransform: 'uppercase',
    marginTop: 'auto',
    width: '100%',
    alignItems: 'end',
    '& .availableCredit': {
      fontSize: theme.spacing(1.5),
      [theme.breakpoints.up('sm')]: { flex: 1, textAlign: 'right' },
      '& .value': {
        fontSize: theme.spacing(2),
        fontWeight: 600,
        [theme.breakpoints.up('sm')]: { fontSize: theme.spacing(2.5) },
      },
    },
    '& .expirationDate': {
      '& .value': {
        fontSize: theme.spacing(2),
        fontWeight: 600,
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: { fontSize: theme.spacing(2) },
      },
    },
  },
}));
